'use client';

import { c as _c } from "react/compiler-runtime";
import { Stack, TextField, Typography, type TextFieldProps } from '@mui/material';
import { InputErrorIcon } from '@/components/form/validation/inputErrorIcon';
const errors: Record<string, string> = {
  EON_ACCOUNT_NOT_FOUND: 'Eon account not found for domain',
  PROJECTS_ERROR: 'Failed to get projects',
  JWT_SECRET_MISSING: 'JWT is missing',
  JWT_SIGNING_ERROR: 'Failed to sign jwt',
  AUTH_HEADER_ERROR: 'Failed to set auth header'
};
export function DomainInput(t0) {
  const $ = _c(23);
  let errorType;
  let props;
  let slotPropsProp;
  if ($[0] !== t0) {
    ({
      errorType,
      slotProps: slotPropsProp,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = errorType;
    $[2] = props;
    $[3] = slotPropsProp;
  } else {
    errorType = $[1];
    props = $[2];
    slotPropsProp = $[3];
  }
  const t1 = errorType === "EON_ACCOUNT_NOT_FOUND";
  const t2 = slotPropsProp?.htmlInput;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      height: "36px",
      paddingRight: 130
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = {
      ...t2,
      id: "login-domain",
      style: t3
    };
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== slotPropsProp || $[8] !== t4) {
    t5 = {
      ...slotPropsProp,
      htmlInput: t4
    };
    $[7] = slotPropsProp;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== props || $[11] !== t1 || $[12] !== t5) {
    t6 = <TextField error={t1} size="medium" placeholder="your-company" slotProps={t5} {...props} />;
    $[10] = props;
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      alignItems: "center",
      gap: "4px",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      right: "12px"
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== errorType) {
    t8 = errorType === "EON_ACCOUNT_NOT_FOUND" && <InputErrorIcon errorMessage={errors[errorType]} />;
    $[15] = errorType;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Typography>.console.eon.io</Typography>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8) {
    t10 = <Stack direction="row" sx={t7}>{t8}{t9}</Stack>;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t6) {
    t11 = <div className="relative">{t6}{t10}</div>;
    $[20] = t10;
    $[21] = t6;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}